import { BentoCard } from '../components/radiant-components/bento-card'
import { Button } from '../components/radiant-components/button'
import { Container } from '../components/radiant-components/container'
import { Footer } from '../components/radiant-components/footer'
import { Gradient } from '../components/radiant-components/gradient'
import { Keyboard } from '../components/radiant-components/keyboard'
import { LogoCluster } from '../components/radiant-components/logo-cluster'
import { Map } from '../components/radiant-components/map'
import { Navbar } from '../components/radiant-components/navbar'
import { Heading } from '../components/radiant-components/text'
import { useNavigate } from 'react-router-dom'
import { useRef  } from 'react'

function Hero({ GotoPage, handleScroll }) {
  return (
    <div className="relative">
      <Gradient className="absolute inset-2 bottom-0 rounded-4xl ring-1 ring-black/5 ring-inset" />
      <Container className="relative">
        <Navbar GotoPage={GotoPage} />
        <div className="pt-16 pb-24 sm:pt-24 sm:pb-32 md:pt-32 md:pb-48">
          <h1 className="font-display text-6xl/[0.9] font-medium tracking-tight text-balance text-gray-950 sm:text-8xl/[0.8] md:text-9xl/[0.8]">
            Perfect product titles
          </h1>
          <p className="mt-8 max-w-lg text-xl/7 font-medium text-gray-950/75 sm:text-2xl/8">
            Google Shopping success comes from clear and clickable product titles.
          </p>
          <div className="mt-12 flex flex-col gap-x-6 gap-y-4 sm:flex-row">
            <Button onClick={handleScroll} className="cursor-pointer">Get started</Button>
            <Button variant="secondary" className="cursor-pointer" onClick={() => GotoPage("/login")}>
              Login
            </Button>
          </div>
        </div>
      </Container>
    </div>
  )
}

function FeatureSection() {
  return (
    <div className="overflow-hidden">
      <Container className="pb-5">
        <Heading as="h2" className="max-w-3xl">
          Solving your product title problems.
        </Heading>
      </Container>
    </div>
  )
}

function BentoSection() {
  return (
    <Container>
      <div className="mt-5 grid grid-cols-1 gap-4 lg:grid-cols-6 lg:grid-rows-1">
        <BentoCard
          eyebrow="Easy"
          title="FeedSumo sits on top"
          description="We sit on to of your existing feed set-up, so no need to change providers, or mess with complicated set-ups."
          graphic={
            <div className="flex size-full pt-10 pl-10">
              <Keyboard highlighted={['LeftCommand', 'LeftShift', 'D']} />
            </div>
          }
          className="lg:col-span-2 lg:rounded-bl-4xl"
        />
        <BentoCard
          eyebrow="Effective"
          title="FeedSumo sits on top"
          description="Should your title feature materials, keywords, brands, technical features? Our AI will try lots of ideas to find what works best for you!"
          graphic={<LogoCluster />}
          className="lg:col-span-2"
        />
        <BentoCard
          eyebrow="SCALE"
          title="Built for agencies"
          description="Do you manage multiple Google accounts? If so, you can use us to make fast effective changes your clients will love!"
          graphic={<Map />}
          className="max-lg:rounded-b-4xl lg:col-span-2 lg:rounded-br-4xl"
        />
      </div>
    </Container>
  )
}

function DarkBentoSection() {
  return (
    <></>
  )
}

export default function Homepage() {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const GotoPage = (pageName, message = "") => {
      if(pageName !== "" && pageName !== "#") {
          setTimeout(() => {
          navigate(`${pageName}`, {state: { message: message }});
          }, 200); // Optional delay for UX smoothness
      }
  };
  const smoothScroll = (targetY, duration = 600) => {
    const startY = window.scrollY;
    const diff = targetY - startY;
    let start;

    const step = timestamp => {
      if (!start) start = timestamp;
      const time = timestamp - start;
      const percent = Math.min(time / duration, 1);

      // Ease-in-out
      const ease = percent < 0.5
        ? 2 * percent * percent
        : -1 + (4 - 2 * percent) * percent;

      window.scrollTo(0, startY + diff * ease);

      if (time < duration) {
        requestAnimationFrame(step);
      }
    };

  requestAnimationFrame(step);
};
  const handleScroll = () => {
    const top = sectionRef.current.offsetTop;
    smoothScroll(top, 900); // 900ms
  };
  return (
    <div className="overflow-hidden">
      <Hero GotoPage={GotoPage} handleScroll={handleScroll}/>
      <main>
        <Container className="mt-10">
        </Container>
        <div className="bg-linear-to-b from-white from-50% to-gray-100 py-10" ref={sectionRef}>
          <FeatureSection />
          <BentoSection />
        </div>
        <DarkBentoSection />
      </main>
      <Footer GotoPage={GotoPage}/>
    </div>
  )
}
